import type {
	CreateTransferMultiplierInput,
	GetAllTransferMultipliersInput,
} from "@/api/custom_types";
import { createReactQueryKeys } from "@/utils/react-query";

interface Keys {
	useGetTransferMultiplier: GetAllTransferMultipliersInput;
	useCreateTransferMultiplier: CreateTransferMultiplierInput;
}

const TRANSFER_MULTIPLIER_KEYS = createReactQueryKeys<Keys>(
	"transfer-multiplier",
	["useGetTransferMultiplier", "useCreateTransferMultiplier"],
);

export { TRANSFER_MULTIPLIER_KEYS };
